const actionTypes = require('constants/actionTypes');
const { APIGet, APIPost } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder');
const notification = require('actions/notifications');
const { formatText } = require('core/i18n').i18n;
const {
    BROKER_ALERT_CONFIGURATION_TYPE_STOCKS_OPTION,
    BROKER_DAX30_STOCK_MARKET_NAME,
    BROKER_IBEX35_STOCK_MARKET_NAME,
    BROKER_PSI20_STOCK_MARKET_NAME,
    BROKER_AEX_STOCK_MARKET_NAME
} = require('constants/index');

const defaultAlerts = [{
    text: 'broker-alertsDefault01'
}, {
    text: 'broker-alertsDefault02'
}];

const createAlert = (data) => (dispatch) => {
    return dispatch({
        type: actionTypes.BROKER_ALERTS_CONFIG_CREATE_ALERT,
        payload: {
            data
        }
    });
};

const createAlertRequest = () => ({
    type: actionTypes.BROKER_ALERTS_CONFIG_CREATE_ALERT_REQUEST
})

const createAlertSuccess = (data) => {
    return {
        type: actionTypes.BROKER_ALERTS_CONFIG_CREATE_ALERT_SUCCESS,
        payload: {
            data
        }
    };
};

const createAlertFailure = (error) => {
    return {
        type: actionTypes.BROKER_ALERTS_CONFIG_CREATE_ALERT_FAILURE,
        payload: {
            error
        }
    };
};

const getConditionsRequest = () => {
    return {
        type: actionTypes.BROKER_ALERTS_CONFIG_GET_CONDITIONS_REQUEST
    };
};

const getConditionsSuccess = (data) => {
    return {
        type: actionTypes.BROKER_ALERTS_CONFIG_GET_CONDITIONS_SUCCESS,
        payload: {
            data
        }
    };
};

const getConditionsFailure = (error) => {
    return {
        type: actionTypes.BROKER_ALERTS_CONFIG_GET_CONDITIONS_FAILURE,
        payload: {
            error
        }
    };
};

const cancelAlert = () => {
    return {
        type: actionTypes.BROKER_ALERTS_CONFIG_CANCEL_ALERT
    };
};

const deleteAlertRequest = (alertId) => {
     return {
        type: actionTypes.BROKER_ALERTS_CONFIG_DELETE_CUSTOM_ALERT_REQUEST,
        payload: {
            alertId
        }
    };
};

const deleteAlertSuccess = (data, alertId) => {
    return {
        type: actionTypes.BROKER_ALERTS_CONFIG_DELETE_CUSTOM_ALERT_SUCCESS,
        payload: {
            data,
            alertId
        }
    };
};

const deleteAlertFailure = (error, alertId) => {
     return {
        type: actionTypes.BROKER_ALERTS_CONFIG_DELETE_CUSTOM_ALERT_FAILURE,
        payload: {
            error,
            alertId
        }
    };
};

const deleteCustomAlert = (immAlert) => (dispatch) => {
    const alertId = immAlert.toJS ? immAlert.get('alertId') : immAlert.alertId;
    const urlParams = {
        id: alertId
    };

    dispatch( deleteAlertRequest(alertId) );
    return APIPost(dispatch, apiURLBuilder.getURL('deleteAlert', urlParams), {})
            .then(response => {
                const message = formatText('broker-deleteAlertSuccess');
                dispatch(notification.success({message}, {voice: message}));
                return dispatch( deleteAlertSuccess(response, alertId) )
            })
            .catch(response => {
                const message = formatText('broker-deleteAlertFailure');
                dispatch(notification.error({message}, {voice: message}));
                dispatch(deleteAlertFailure(response, alertId))
            });
};

const editCustomAlert = (alert) => (dispatch, getState) => {
    const alertId = alert.get('alertId');
    const immAlert = getState().brokerAlertsConfig.getIn(['customAlerts', 'byId', alertId]);
    const selectedValues = {
        alertId,
        productExchangeId: immAlert.get('exchangeId'),
        productId: immAlert.get('alertId'),
        productName: immAlert.get('instrument'),
        productSpcSymbol: immAlert.get('spcSymbol'),
        productTradePrice: immAlert.get('tradePrice'),
        rateType: immAlert.get('conditionId'),
        rateLabel: immAlert.get('conditionName'),
        rateValue: immAlert.get('conditionValue')
    };

    let configurationType;
    if (immAlert.get('instrument') === BROKER_IBEX35_STOCK_MARKET_NAME
        || immAlert.get('instrument') === BROKER_DAX30_STOCK_MARKET_NAME
        || immAlert.get('instrument') === BROKER_PSI20_STOCK_MARKET_NAME
        || immAlert.get('instrument') === BROKER_AEX_STOCK_MARKET_NAME) {
        configurationType = immAlert.get('instrument').replace(/ +/g, "");
    } else {
        configurationType = BROKER_ALERT_CONFIGURATION_TYPE_STOCKS_OPTION;
    }

    return dispatch({
        type: actionTypes.BROKER_ALERTS_CONFIG_EDIT_CUSTOM_ALERT,
        payload: {
            alertId,
            configurationType,
            selectedValues
        }
    });
};

const validateForm = () => {
    return {
        type: actionTypes.BROKER_ALERTS_CONFIG_VALIDATE_FORM
    };
};

const validateIndexForm = (indexName) => {
    return {
        type: actionTypes.BROKER_ALERTS_CONFIG_VALIDATE_INDEX_FORM,
        payload: {
            indexName
        }
    };
};

const handleSubmit = () => (dispatch, getState) => {
    dispatch(validateForm());

    const immAlertsConfig = getState().brokerAlertsConfig;
    const valid = immAlertsConfig.getIn(['selectedValues', 'stocks', 'isFormValid']);
    if (valid) {
        const immValues = immAlertsConfig.getIn(['selectedValues', 'stocks']);
        const requestData = {
            query: {
                spcSymbol: immValues.get('productSpcSymbol'),
                exchangeId: immValues.get('productExchangeId'),
                tradePrice: immValues.get('productTradePrice'),
                conditionId: immValues.get('rateType'),
                conditionValue: immValues.get('rateValue'),
                actionId: "EML", // (Andres): This id indicated to send the alert to API
                endDate: "2050-01-01", // (Andres): Huge date so it never expires
                typePrice: "T" // (Andres): This should be T always, at least until the user can choose a value
                               // Tipo de precio:
                               // T: Precio de negociación.
                               // A: Precio de oferta o venta (Ask).
                               // B: Precio de demanda o de compra (Bid)
            }
        };

        dispatch(createAlertRequest());

        return APIPost(dispatch, apiURLBuilder.getURL('createAlert'), requestData)
            .then(response => {
                const message = formatText('broker-createAlertSuccess');
                dispatch(notification.success({message}, {voice: message}));
                return dispatch( createAlertSuccess(response) )
            })
            .catch(response => {
                if (immValues.get('rateType')) {
                    const message = formatText('broker-createAlertFailure');
                    dispatch(notification.error({message}, {voice: message}))
                }
                dispatch(createAlertFailure(response))
            });
    }
}

const updateAlertRequest = () => {
    return {
        type: actionTypes.BROKER_ALERTS_CONFIG_EDIT_CUSTOM_ALERT_REQUEST
    };
};

const updateAlertFailure = (error) => {
    return {
        type: actionTypes.BROKER_ALERTS_CONFIG_EDIT_CUSTOM_ALERT_FAILURE,
        payload: {
            error
        }
    };
};

const updateAlertSuccess = (data, alertId) => {
    return {
        type: actionTypes.BROKER_ALERTS_CONFIG_EDIT_CUSTOM_ALERT_SUCCESS,
        payload: {
            data,
            alertId
        }
    };
};

const updateCustomAlert = (data) => (dispatch, getState) => {
    dispatch(validateForm());
    const alertId = data.alertId;
    const immAlertsConfig = getState().brokerAlertsConfig;
    const valid = immAlertsConfig.getIn(['selectedValues', 'stocks', 'isFormValid']);
    if (valid) {
        const urlParamsToEditOriginalAlert = {
            id: alertId
        };

        dispatch(updateAlertRequest());

        const immValues = immAlertsConfig.getIn(['selectedValues', 'stocks']);
        const requestData = {
            query: {
                spcSymbol: immValues.get('productSpcSymbol'),
                exchangeId: immValues.get('productExchangeId'),
                tradePrice: immValues.get('productTradePrice'),
                conditionId: immValues.get('rateType'),
                conditionValue: immValues.get('rateValue'),
                actionId: "EML", // (Andres): This id indicated to send the alert to API
                endDate: "2050-01-01", // (Andres): Huge date so it never expires
                typePrice: "T" // (Andres): This should be T always, at least until the user can choose a value
                               // Tipo de precio:
                               // T: Precio de negociación.
                               // A: Precio de oferta o venta (Ask).
                               // B: Precio de demanda o de compra (Bid)
            }
        };

        // (Andres) Let's create a new alert
        return APIPost(dispatch, apiURLBuilder.getURL('createAlert'), requestData)
            .then((createAlertResponse) => {

                // (Andres): If we created the new alert, let's remove the old one
                return APIPost(dispatch, apiURLBuilder.getURL('deleteAlert', urlParamsToEditOriginalAlert), {})
                    .then(() => {

                        // (Andres): Edition process complete
                        const message = formatText('broker-editAlertSuccess');
                        dispatch(notification.success({message}, {voice: message}));
                        dispatch(updateAlertSuccess(immAlertsConfig.get('selectedValues'), alertId));
                    })
                    .catch(response => {
                        // (Andres): The edition process failed, but since the edition is just creating a new one and deleting the old one,
                        // if we succeded creating the new one and failed to delete the old one, let's
                        // delete the new one too, so for the user, nothing will have changed
                        APIPost(dispatch, apiURLBuilder.getURL('deleteAlert', { id:  createAlertResponse.spuAlertAddResult}), {})
                            .then(() => {
                                const message = formatText('broker-editAlertFailure');
                                dispatch(notification.success({message}, {voice: message}));
                                dispatch(updateAlertFailure(response));
                            })
                            .catch(response => {
                                const message = formatText('broker-editAlertFailure');
                                dispatch(notification.error({message}, {voice: message}));
                                dispatch(updateAlertFailure(response));
                            });
                    });
            })
            .catch(response => {
                const message = formatText('broker-editAlertFailure');
                dispatch(notification.error({message}, {voice: message}));
                dispatch(updateAlertFailure(response));
            });
    }
};

const updateIndexAlert = (indexName) => (dispatch, getState) => {
    dispatch(validateIndexForm(indexName));
    const immAlertsConfig = getState().brokerAlertsConfig;
    const valid = immAlertsConfig.getIn(['selectedValues', indexName, 'isFormValid']);

    if (valid) {
        const alertId = immAlertsConfig.getIn(['selectedValues', 'alertId']);
        const requestData = {
            query: {
                actionId: 'EML', // (Andres): This id indicated to send the alert to API
                conditionId: immAlertsConfig.getIn(['selectedValues', indexName, 'rateType']),
                conditionValue: immAlertsConfig.getIn(['selectedValues', indexName, 'rateValue']),
                endDate: '2050-01-01', // (Andres): Huge date so it never expires,
                executions: 0, // (JJ) Ask again in the future, but for now "executions" is always 0,,
                indexId: indexName,
                tradePrice: 10500, // @hardcoded
                typePrice: 'T' // (Andres): This should be T always, at least until the user can choose a value
                                // Tipo de precio:
                                // T: Precio de negociación.
                                // A: Precio de oferta o venta (Ask).
                                // B: Precio de demanda o de compra (Bid)
            }
        };

        dispatch(updateAlertRequest());

        APIPost(dispatch, apiURLBuilder.getURL('updateIndexAlert', { id: alertId }), requestData)
            .then(
                () => {
                    const message = formatText('broker-editAlertSuccess');
                    dispatch(notification.success({ message }, { voice: message }));
                    dispatch(updateAlertSuccess(immAlertsConfig.get('selectedValues'), alertId));
                },
                (error) => {
                    const message = formatText('broker-editAlertFailure');
                    dispatch(notification.error({ message }, { voice: message }));
                    dispatch(updateAlertFailure(error));
                }
            )
    }
};

const getAlertsRequest = () => {
    return {
        type: actionTypes.BROKER_ALERTS_CONFIG_GET_ALERTS_REQUEST
    };
};

const getAlertsSuccess = (data) => {
    return {
        type: actionTypes.BROKER_ALERTS_CONFIG_GET_ALERTS_SUCCESS,
        payload: {
            data
        }
    };
};

const getAlertsFailure = (error) => {
    return {
        type: actionTypes.BROKER_ALERTS_CONFIG_GET_ALERTS_FAILURE,
        payload: {
            error
        }
    };
};

const getDefaultAlerts = () => {
    return {
        type: actionTypes.BROKER_ALERTS_CONFIG_GET_DEFAULT_ALERTS,
        payload: {
            data: defaultAlerts
        }
    };
};

const disableProductError = () => {
    return {
        type: actionTypes.BROKER_ALERTS_CONFIG_DISABLE_PRODUCT_ERROR,
    };
};

const disableRateTypeError = () => {
    return {
        type: actionTypes.BROKER_ALERTS_CONFIG_DISABLE_QUOTE_TYPE_ERROR,
    };
};

const disableRateValueError = () => {
    return {
        type: actionTypes.BROKER_ALERTS_CONFIG_DISABLE_QUOTE_VALUE_ERROR,
    };
};

const changeConfigurationType = (type, indexName) => {
    return {
        type: actionTypes.BROKER_ALERTS_CONFIG_CONFIGURATION_TYPE_CHANGE,
        payload: {
            type,
            indexName
        }
    };
}

const selectProduct = (product) => {
    return {
        type: actionTypes.BROKER_ALERTS_CONFIG_SELECT_PRODUCT,
        payload: {
            product
        }
    };
};

const selectRateType = (option) => {
    return {
        type: actionTypes.BROKER_ALERTS_CONFIG_SELECT_RATE_TYPE,
        payload: {
            rateType: option.value,
            rateLabel: option.label
        }
    };
};

const selectRateValue = (rate) => {
    return {
        type: actionTypes.BROKER_ALERTS_CONFIG_SELECT_RATE_VALUE,
        payload: {
            rate
        }
    };
};

const selectRateTypeForIndex = (option, defaultIndexName) => {
    return {
        type: actionTypes.BROKER_ALERTS_CONFIG_SELECT_RATE_TYPE_FOR_INDEX,
        payload: {
            rateType: option.value,
            rateLabel: option.label,
            indexName: defaultIndexName
        }
    };
};

const selectRateValueForIndex = (rate, indexName) => {
    return {
        type: actionTypes.BROKER_ALERTS_CONFIG_SELECT_RATE_VALUE_FOR_INDEX,
        payload: {
            rate,
            indexName
        }
    };
};

const requestConditions = () => (dispatch) => {
    const requestData = {
        query: {
            pageNum: 0,
            pageSize: 0
        }
    };

    dispatch( getConditionsRequest() );

    return APIGet(dispatch, apiURLBuilder.getURL('getAlertsConditions'), requestData)
        .then(response => dispatch( getConditionsSuccess(response) ))
        .catch(response => dispatch( getConditionsFailure(response) ));
};

const requestCustomAlerts = () => (dispatch, getState) => {
    const getAlertsFetchSuccess = getState().brokerAlertsConfig.get('getAlertsFetchSuccess');
    const isGettingAlerts = getState().brokerAlertsConfig.get('isGettingAlerts');
    const customAlertsAreOutdated = getState().brokerAlertsConfig.get('customAlertsAreOutdated');

    if ( (getAlertsFetchSuccess || isGettingAlerts) && !customAlertsAreOutdated ) {
        return Promise.resolve();
    }

    const requestData = {
        query: {
            pageNum: 0,
            pageSize: 0
        }
    };

    dispatch( getAlertsRequest() );

    return APIGet(dispatch, apiURLBuilder.getURL('getAlerts'), requestData)
        .then(response => dispatch( getAlertsSuccess(response) ))
        .catch(response => dispatch( getAlertsFailure(response) ));
};

const handleIndexSubmit = (indexName) => (dispatch, getState) => {
    dispatch(validateIndexForm(indexName));
    const immAlertsConfig = getState().brokerAlertsConfig;

    const valid = immAlertsConfig.getIn(['selectedValues', indexName, 'isFormValid']);
    if (valid) {
        const immValues = immAlertsConfig.getIn(['selectedValues', indexName]);
        const requestData = {
            query: {
                actionId: "EML", // (Andres): This id indicated to send the alert to API
                conditionId: immValues.get('rateType'),
                conditionValue: immValues.get('rateValue'),
                endDate: "2050-01-01", // (Andres): Huge date so it never expires
                executions: 0, // (JJ) Ask again in the future, but for now "executions" is always 0,
                indexId: indexName,
                tradePrice: 10500, // @hardcoded
                typePrice: "T" // (Andres): This should be T always, at least until the user can choose a value
                               // Tipo de precio:
                               // T: Precio de negociación.
                               // A: Precio de oferta o venta (Ask).
                               // B: Precio de demanda o de compra (Bid)
            }
        };

        dispatch(createAlertRequest());

        return APIPost(dispatch, apiURLBuilder.getURL('createIndexAlert'), requestData)
            .then(
                response => {
                    const message = formatText('broker-createAlertSuccess');
                    dispatch(notification.success({ message }, { voice: message }));
                    return dispatch(createAlertSuccess(response))
                },
                response => {
                    if (immValues.get('rateType')) {
                        const message = formatText('broker-createAlertFailure');
                        dispatch(notification.error({ message }, { voice: message }));
                    }
                    dispatch(createAlertFailure(response));
                }
            );
    }
};

const reset = () => ({
        type: actionTypes.BROKER_ALERTS_CONFIG_RESET
});

const resetSelectedValuesStocks = () => ({
    type: actionTypes.BROKER_ALERTS_CONFIG_RESET_SELECTED_VALUES_STOCKS
});

const resetSelectedValuesForIndex = (indexName) => ({
    type: actionTypes.BROKER_ALERTS_CONFIG_RESET_SELECTED_VALUES_FOR_INDEX,
    payload: {
        indexName
    }
});

module.exports = {
    createAlert,
    selectProduct,
    selectRateType,
    selectRateTypeForIndex,
    selectRateValue,
    selectRateValueForIndex,
    changeConfigurationType,
    updateCustomAlert,
    cancelAlert,
    deleteCustomAlert,
    editCustomAlert,
    requestCustomAlerts,
    getDefaultAlerts,
    handleSubmit,
    handleIndexSubmit,
    disableProductError,
    disableRateTypeError,
    disableRateValueError,
    requestConditions,
    reset,
    resetSelectedValuesForIndex,
    resetSelectedValuesStocks,
    updateIndexAlert
};
